import React, { useEffect, useState } from 'react'
import { Grid } from '@material-ui/core'
import { useDispatch } from 'react-redux'
import { endOfMonth, startOfMonth } from 'date-fns'
import BaseRelatoryPage from '../../../components/hooks/BaseRelatoryPage'
import Filter from './Filter'
import List from './List'
import { fetchCatalogacaoRelatory } from '../CatalogacaoRelatoryActions'

const CatalogacaoRelatory = () => {
  const dispatch = useDispatch()

  const [form, setForm] = useState({
    rows: 10,
    page: 1,
    date_start: startOfMonth(new Date()),
    date_end: endOfMonth(new Date()),
  })

  useEffect(() => {
    dispatch(fetchCatalogacaoRelatory(form))
  }, [])

  useEffect(() => {
    dispatch(fetchCatalogacaoRelatory(form))
  }, [form])

  return (
    <BaseRelatoryPage title="Alterações na Catalogação">
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12}>
          <Filter form={form} setForm={setForm} />
        </Grid>

        <Grid item xs={12}>
          <List form={form} setForm={setForm} />
        </Grid>
      </Grid>
    </BaseRelatoryPage>
  )
}

export default CatalogacaoRelatory
